import Action from '../../actions/templates'
import { IEvent } from '../../models/Event'
import { ITemplate } from '../../models/Templates'
import { TemplatesActions, TemplateSend } from './actionNames'
import initialStore from './initialState'
import openTemplateSendModal from './mutators/openTemplateSendModal'
import requestForTemplates from './mutators/requestForTemplates'
import templatesAreAccepted from './mutators/templatesAreAccepted'
import templatesAreRejected from './mutators/templatesAreRejected'
import toggleTemplateSendModal from './mutators/toggleTemplateSendModal'

export default function(
  store: Readonly<ITemplatesStore> = initialStore,
  action: Action & any,
) {
  switch (action.type) {
    case TemplatesActions.RequestForTemplates:
      return requestForTemplates(store)
    case TemplatesActions.TemplatesAreAccepted:
      return templatesAreAccepted(store, action)
    case TemplatesActions.TemplatesAreRejected:
      return templatesAreRejected(store, action)
    case TemplateSend.ToggleTemplateSendModal:
      return toggleTemplateSendModal(store, action)
    case TemplateSend.OpenTemplateSendModal:
      return openTemplateSendModal(store)
  }

  return store
}

export interface ITemplatesStore {
  templates: ITemplate[]
  grouped: any
  templateSendModal: {
    isLoading: boolean
    email: string
    open: boolean
    event: IEvent
  }
  request: IRequest
}

interface IRequest {
  isLoading: boolean
  errMessage: string
}
